// https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
import 'classlist-polyfill'
export default function (elem) {
    return elem.classList
}
